
window.getCookie = function(name) {
  match = document.cookie.match(new RegExp(name + '=([^;]+)'));
  if (match) return match[1];
}

function doOnce() { 
  if (!(localStorage.getItem('riversol_first_visit') || getCookie('riversol_first_visit'))) {
    console.log("It's your first visit - Welcome!")
    var url = window.location.href.replace(/&/g,"%26");
    localStorage.setItem("riversol_first_visit", url);
    document.cookie = "riversol_first_visit=" + url + "; expires=Fri, 31 Dec 9999 23:59:59 GMT";
  }

  if(!sessionStorage.getItem('riversol_landing_url')) {
    var url_l = encodeURIComponent(window.location.href);
    sessionStorage.setItem("riversol_landing_url", url_l);
  }

  if(!sessionStorage.getItem('riversol_referring_url')) {
    var url_r = encodeURIComponent(document.referrer);
    sessionStorage.setItem("riversol_referring_url", url_r);
  }
}
doOnce();